import React, { useState } from 'react';
import { Box, Typography, TextField, IconButton, List, ListItem, Button, Card, CardContent } from '@mui/material';
import { Delete, Add } from '@mui/icons-material';

const InclusionsExclusionsEditor = ({ inclusions, setInclusions, exclusions, setExclusions }) => {
    const [newInclusion, setNewInclusion] = useState('');
    const [newExclusion, setNewExclusion] = useState('');

    const handleAddInclusion = () => {
        if (newInclusion.trim()) {
            setInclusions([...inclusions, newInclusion.trim()]);
            setNewInclusion('');
        }
    };

    const handleRemoveInclusion = (index) => {
        const newInc = [...inclusions];
        newInc.splice(index, 1);
        setInclusions(newInc);
    };

    const handleAddExclusion = () => {
        if (newExclusion.trim()) {
            setExclusions([...exclusions, newExclusion.trim()]);
            setNewExclusion('');
        }
    };

    const handleRemoveExclusion = (index) => {
        const newExc = [...exclusions];
        newExc.splice(index, 1);
        setExclusions(newExc);
    };

    const handleInclusionChange = (index, value) => {
        const newInc = [...inclusions];
        newInc[index] = value;
        setInclusions(newInc);
    };

    const handleExclusionChange = (index, value) => {
        const newExc = [...exclusions];
        newExc[index] = value;
        setExclusions(newExc);
    };

    return (
        <Card sx={{ mb: 3, boxShadow: 2 }}>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                    Inclusions & Exclusions (For PDF Only)
                </Typography>
                <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', md: 'row' } }}>
            <Box sx={{ flex: 1, bgcolor: '#f1f8e9', p: 2, borderRadius: 2 }}>
                <Typography variant="h6" color="success.main" gutterBottom>Inclusions</Typography>
                <List dense>
                    {inclusions.map((inc, idx) => (
                        <ListItem key={idx} disablePadding sx={{ mb: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                value={inc}
                                onChange={(e) => handleInclusionChange(idx, e.target.value)}
                            />
                            <IconButton color="error" onClick={() => handleRemoveInclusion(idx)}>
                                <Delete />
                            </IconButton>
                        </ListItem>
                    ))}
                </List>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Add new inclusion..."
                        value={newInclusion}
                        onChange={(e) => setNewInclusion(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleAddInclusion()}
                    />
                    <Button variant="contained" color="success" onClick={handleAddInclusion} sx={{ minWidth: '40px', p: 1 }}>
                        <Add />
                    </Button>
                </Box>
            </Box>

            <Box sx={{ flex: 1, bgcolor: '#ffebee', p: 2, borderRadius: 2 }}>
                <Typography variant="h6" color="error.main" gutterBottom>Exclusions</Typography>
                <List dense>
                    {exclusions.map((exc, idx) => (
                        <ListItem key={idx} disablePadding sx={{ mb: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                value={exc}
                                onChange={(e) => handleExclusionChange(idx, e.target.value)}
                            />
                            <IconButton color="error" onClick={() => handleRemoveExclusion(idx)}>
                                <Delete />
                            </IconButton>
                        </ListItem>
                    ))}
                </List>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Add new exclusion..."
                        value={newExclusion}
                        onChange={(e) => setNewExclusion(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleAddExclusion()}
                    />
                    <Button variant="contained" color="error" onClick={handleAddExclusion} sx={{ minWidth: '40px', p: 1 }}>
                        <Add />
                    </Button>
                </Box>
            </Box>
        </Box>
        </CardContent>
        </Card>
    );
};

export default InclusionsExclusionsEditor;
